import { userManager } from './user-manager';

const hasAuthParams = (params: URLSearchParams) =>
    params.has('code') && params.has('session_state') && params.has('iss');

export const removeOidcParams = (url: URL) => {
    url.searchParams.delete('state');
    url.searchParams.delete('session_state');
    url.searchParams.delete('iss');
    url.searchParams.delete('code');
};

const retrySignin = async () => {
    const url = new URL(window.location.href);
    removeOidcParams(url);
    const cleanUrl = url.toString();

    await userManager.signinRedirect({
        redirectMethod: 'replace',
        redirect_uri: cleanUrl,
    });
};

/**
 * Processes a magic link authentication URL containing authorization code
 */
export const processMagicLinkAuth = async (): Promise<boolean> => {
    try {
        const url = new URL(window.location.href);
        const user = await userManager.processSignIn(url.toString());

        if (user && !user.expired) {
            // Replace the current URL without the auth parameters
            removeOidcParams(url);
            const cleanUrl = url.toString();
            window.history.replaceState({}, '', cleanUrl);
            return true;
        }

        return false;
    } catch (error) {
        const errorMessage = String(error);
        const noState = errorMessage.includes('No state in response');

        if (noState) {
            await retrySignin().catch(() => {
                console.error('Error retrying signin:', error);
            });
        }

        return false;
    }
};

/**
 * Handles magic link authentication if detected in the URL
 */
export const handleMagicLinkAuth = async (): Promise<void> => {
    const params = new URLSearchParams(window.location.search);

    if (!hasAuthParams(params)) return;

    if (!params.has('state')) {
        await retrySignin();
    } else {
        await processMagicLinkAuth();
    }
};
